module.exports = "/_next/static/images/TeamPlan-sm@2x-cffca70c5dcd29578895d4f8633de501.png";